// extracted by mini-css-extract-plugin
export default {"AboutMe":"About_AboutMe__BallL","Container":"About_Container__P4xU7","Text":"About_Text__HmE6Q","Photo":"About_Photo__3vGAM","Me":"About_Me__xL9FI"};